/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { MasterZoneListItemDto } from './master-zone-list-item.dto';

export const MasterZoneListItemMapper = entity<MasterZoneListItemDto>();
